<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9025_76021)">
      <path d="M15.6612 15.3726C9.59115 15.3726 4.68115 20.2926 4.68115 26.3526V29.9026H8.68115V29.8426H22.6812V29.9026H26.6812V26.4009C26.6812 22.9795 25.1273 19.9193 22.6812 17.9026V17.9156C20.779 16.3281 18.3318 15.3726 15.6612 15.3726Z"
            fill="#E8E1E9"
      />
      <path d="M15.6612 15.3726C9.59115 15.3726 4.68115 20.2926 4.68115 26.3526V29.9026H8.68115V29.8426H22.6812V29.9026H26.6812V26.4009C26.6812 22.9795 25.1273 19.9193 22.6812 17.9026V17.9156C20.779 16.3281 18.3318 15.3726 15.6612 15.3726Z"
            fill="url(#paint0_radial_9025_76021)"
      />
      <path d="M22.6812 29.9028H26.6812V26.4012C26.6812 22.9798 25.1273 19.9196 22.6812 17.9028V29.9028Z"
            fill="url(#paint1_linear_9025_76021)"
      />
      <path d="M22.6812 29.9028H26.6812V26.4012C26.6812 22.9798 25.1273 19.9196 22.6812 17.9028V29.9028Z"
            fill="url(#paint2_radial_9025_76021)"
      />
      <path d="M8.68115 17.8755C6.23755 19.89 4.68115 22.9406 4.68115 26.3525V29.9025H8.68115V17.8755Z"
            fill="url(#paint3_linear_9025_76021)"
      />
      <path d="M8.68115 17.8755C6.23755 19.89 4.68115 22.9406 4.68115 26.3525V29.9025H8.68115V17.8755Z"
            fill="url(#paint4_linear_9025_76021)"
      />
      <path d="M8.68115 17.8755C6.23755 19.89 4.68115 22.9406 4.68115 26.3525V29.9025H8.68115V17.8755Z"
            fill="url(#paint5_radial_9025_76021)"
      />
      <path d="M8.68115 17.8755C6.23755 19.89 4.68115 22.9406 4.68115 26.3525V29.9025H8.68115V17.8755Z"
            fill="url(#paint6_radial_9025_76021)"
      />
      <g filter="url(#filter0_i_9025_76021)">
        <path d="M8.68115 17.9028H18.7335C20.9101 17.9028 22.6812 19.6988 22.6812 21.9062V29.9028H8.68116L8.68115 17.9028Z"
              fill="url(#paint7_radial_9025_76021)"
        />
        <path d="M8.68115 17.9028H18.7335C20.9101 17.9028 22.6812 19.6988 22.6812 21.9062V29.9028H8.68116L8.68115 17.9028Z"
              fill="url(#paint8_radial_9025_76021)"
        />
      </g>
      <path d="M8.68115 17.9028H18.7335C20.9101 17.9028 22.6812 19.6988 22.6812 21.9062V29.9028H8.68116L8.68115 17.9028Z"
            fill="url(#paint9_radial_9025_76021)"
      />
      <path d="M8.68115 17.9028H18.7335C20.9101 17.9028 22.6812 19.6988 22.6812 21.9062V29.9028H8.68116L8.68115 17.9028Z"
            fill="url(#paint10_linear_9025_76021)"
      />
      <g filter="url(#filter1_f_9025_76021)">
        <path d="M15.3942 17.3981C15.0097 17.4304 13.99 17.6504 13.292 18.5407C12.8226 19.1395 12.7938 19.9807 12.7723 20.6091C12.7683 20.7262 12.7645 20.8359 12.7582 20.9352C12.749 21.0805 12.723 21.1986 12.6884 21.2978C12.6344 21.4523 12.7284 21.6395 12.888 21.6296C13.468 21.5935 13.9061 21.467 14.5525 20.9243C15.0447 20.511 15.2948 19.8619 15.4034 19.2079C15.447 19.8694 15.6317 20.5401 16.0807 21C16.6703 21.6039 17.0938 21.773 17.6674 21.8662C17.8253 21.8918 17.9373 21.7148 17.8988 21.5557C17.8742 21.4536 17.86 21.3335 17.8652 21.188C17.8687 21.0885 17.8758 20.979 17.8834 20.8621C17.924 20.2346 17.9784 19.3947 17.5704 18.7525C16.9638 17.7976 15.9708 17.478 15.5914 17.4078C15.5442 17.5681 15.499 17.7671 15.4637 17.9906C15.4506 17.7647 15.4253 17.5622 15.3942 17.3981Z"
              fill="url(#paint11_linear_9025_76021)"
        />
      </g>
      <path d="M23.091 18.2576H8.24219C10.1953 16.4663 12.7994 15.3726 15.6614 15.3726C19.1454 15.3726 20.8144 16.1839 23.091 18.2576Z"
            fill="url(#paint12_radial_9025_76021)"
      />
      <path d="M23.091 18.2576H8.24219C10.1953 16.4663 12.7994 15.3726 15.6614 15.3726C19.1454 15.3726 20.8144 16.1839 23.091 18.2576Z"
            fill="url(#paint13_radial_9025_76021)"
      />
      <g filter="url(#filter2_f_9025_76021)">
        <path d="M20.4717 28.1777C20.4717 28.5919 20.1359 28.9277 19.7217 28.9277C19.3075 28.9277 18.9717 28.5919 18.9717 28.1777C18.9717 27.7635 19.3075 27.4277 19.7217 27.4277C20.1359 27.4277 20.4717 27.7635 20.4717 28.1777Z"
              fill="#BFA9D1"
        />
      </g>
      <g filter="url(#filter3_f_9025_76021)">
        <path d="M19.7217 25.2876C20.1359 25.2876 20.4717 24.9518 20.4717 24.5376C20.4717 24.1234 20.1359 23.7876 19.7217 23.7876C19.3075 23.7876 18.9717 24.1234 18.9717 24.5376C18.9717 24.9518 19.3075 25.2876 19.7217 25.2876Z"
              fill="#BFA9D1"
        />
      </g>
      <g filter="url(#filter4_f_9025_76021)">
        <path d="M19.7217 21.6577C20.1359 21.6577 20.4717 21.3219 20.4717 20.9077C20.4717 20.4935 20.1359 20.1577 19.7217 20.1577C19.3075 20.1577 18.9717 20.4935 18.9717 20.9077C18.9717 21.3219 19.3075 21.6577 19.7217 21.6577Z"
              fill="#C1A0C0"
        />
      </g>
      <g filter="url(#filter5_ii_9025_76021)">
        <path d="M20.7412 28.0327C20.7412 28.4469 20.4054 28.7827 19.9912 28.7827C19.577 28.7827 19.2412 28.4469 19.2412 28.0327C19.2412 27.6185 19.577 27.2827 19.9912 27.2827C20.4054 27.2827 20.7412 27.6185 20.7412 28.0327Z"
              fill="url(#paint14_linear_9025_76021)"
        />
      </g>
      <g filter="url(#filter6_ii_9025_76021)">
        <path d="M19.9912 25.1426C20.4054 25.1426 20.7412 24.8068 20.7412 24.3926C20.7412 23.9784 20.4054 23.6426 19.9912 23.6426C19.577 23.6426 19.2412 23.9784 19.2412 24.3926C19.2412 24.8068 19.577 25.1426 19.9912 25.1426Z"
              fill="url(#paint15_linear_9025_76021)"
        />
      </g>
      <g filter="url(#filter7_ii_9025_76021)">
        <path d="M19.9912 21.5127C20.4054 21.5127 20.7412 21.1769 20.7412 20.7627C20.7412 20.3485 20.4054 20.0127 19.9912 20.0127C19.577 20.0127 19.2412 20.3485 19.2412 20.7627C19.2412 21.1769 19.577 21.5127 19.9912 21.5127Z"
              fill="url(#paint16_linear_9025_76021)"
        />
      </g>
      <path d="M26.6638 22.9595C27.1957 22.9595 27.6309 23.3946 27.6309 23.9265V26.1411H25.6968V23.9265C25.7064 23.3946 26.132 22.9595 26.6638 22.9595Z"
            fill="url(#paint17_radial_9025_76021)"
      />
      <path d="M26.6638 22.9595C27.1957 22.9595 27.6309 23.3946 27.6309 23.9265V26.1411H25.6968V23.9265C25.7064 23.3946 26.132 22.9595 26.6638 22.9595Z"
            fill="url(#paint18_radial_9025_76021)"
      />
      <path d="M13.4687 18.5865C14.1388 17.6628 15.1727 17.3926 15.5652 17.3413C15.7704 18.1714 15.8731 20.0083 14.8814 20.9049C14.2465 21.4789 13.8039 21.6268 13.2113 21.6916C13.0482 21.7094 12.9425 21.5271 12.9899 21.37C13.0204 21.2693 13.041 21.1501 13.0431 21.0045C13.0521 20.3705 12.934 19.3235 13.4687 18.5865Z"
            fill="url(#paint19_radial_9025_76021)"
      />
      <path d="M13.4687 18.5865C14.1388 17.6628 15.1727 17.3926 15.5652 17.3413C15.7704 18.1714 15.8731 20.0083 14.8814 20.9049C14.2465 21.4789 13.8039 21.6268 13.2113 21.6916C13.0482 21.7094 12.9425 21.5271 12.9899 21.37C13.0204 21.2693 13.041 21.1501 13.0431 21.0045C13.0521 20.3705 12.934 19.3235 13.4687 18.5865Z"
            fill="url(#paint20_radial_9025_76021)"
      />
      <path d="M13.4687 18.5865C14.1388 17.6628 15.1727 17.3926 15.5652 17.3413C15.7704 18.1714 15.8731 20.0083 14.8814 20.9049C14.2465 21.4789 13.8039 21.6268 13.2113 21.6916C13.0482 21.7094 12.9425 21.5271 12.9899 21.37C13.0204 21.2693 13.041 21.1501 13.0431 21.0045C13.0521 20.3705 12.934 19.3235 13.4687 18.5865Z"
            fill="url(#paint21_radial_9025_76021)"
      />
      <path d="M17.8643 18.5865C17.1942 17.6628 16.1603 17.3926 15.7678 17.3413C15.5626 18.1714 15.4599 20.0083 16.4516 20.9049C17.0865 21.4789 17.5291 21.6268 18.1217 21.6916C18.2848 21.7094 18.3905 21.5271 18.3431 21.37C18.3126 21.2693 18.292 21.1501 18.2899 21.0045C18.2809 20.3705 18.399 19.3235 17.8643 18.5865Z"
            fill="url(#paint22_radial_9025_76021)"
      />
      <path d="M17.8643 18.5865C17.1942 17.6628 16.1603 17.3926 15.7678 17.3413C15.5626 18.1714 15.4599 20.0083 16.4516 20.9049C17.0865 21.4789 17.5291 21.6268 18.1217 21.6916C18.2848 21.7094 18.3905 21.5271 18.3431 21.37C18.3126 21.2693 18.292 21.1501 18.2899 21.0045C18.2809 20.3705 18.399 19.3235 17.8643 18.5865Z"
            fill="url(#paint23_linear_9025_76021)"
      />
      <path d="M17.8643 18.5865C17.1942 17.6628 16.1603 17.3926 15.7678 17.3413C15.5626 18.1714 15.4599 20.0083 16.4516 20.9049C17.0865 21.4789 17.5291 21.6268 18.1217 21.6916C18.2848 21.7094 18.3905 21.5271 18.3431 21.37C18.3126 21.2693 18.292 21.1501 18.2899 21.0045C18.2809 20.3705 18.399 19.3235 17.8643 18.5865Z"
            fill="url(#paint24_radial_9025_76021)"
      />
      <path d="M17.8643 18.5865C17.1942 17.6628 16.1603 17.3926 15.7678 17.3413C15.5626 18.1714 15.4599 20.0083 16.4516 20.9049C17.0865 21.4789 17.5291 21.6268 18.1217 21.6916C18.2848 21.7094 18.3905 21.5271 18.3431 21.37C18.3126 21.2693 18.292 21.1501 18.2899 21.0045C18.2809 20.3705 18.399 19.3235 17.8643 18.5865Z"
            fill="url(#paint25_radial_9025_76021)"
      />
      <g filter="url(#filter8_ii_9025_76021)">
        <path d="M14.9932 17.4606C15.1836 17.3975 15.4334 17.3413 15.7004 17.3413C15.9675 17.3413 16.2172 17.3975 16.4077 17.4606C16.5961 17.523 16.6989 17.7158 16.6619 17.9108C16.5696 18.3973 16.3926 18.7114 16.1984 18.8999C16.1316 18.9647 16.0402 19.0116 15.9308 19.0311C15.8215 19.0506 15.5931 19.0623 15.4543 19.0311C15.3154 18.9998 15.2692 18.9647 15.2024 18.8999C15.0082 18.7114 14.8312 18.3973 14.7389 17.9108C14.7019 17.7158 14.8047 17.523 14.9932 17.4606Z"
              fill="url(#paint26_linear_9025_76021)"
        />
      </g>
      <g filter="url(#filter9_i_9025_76021)">
        <path d="M26.0605 21.076C26.0605 20.6705 26.3201 20.3184 26.6284 20.055C27.2332 19.5383 27.6308 18.6633 27.6308 17.6709C27.6308 16.0831 26.613 14.7959 25.3574 14.7959C24.1018 14.7959 23.084 16.0831 23.084 17.6709C23.084 18.6634 23.4816 19.5384 24.0864 20.055C24.3948 20.3184 24.6543 20.6705 24.6543 21.076V26.1318H26.0605V21.076Z"
              fill="#ECA779"
        />
        <path d="M26.0605 21.076C26.0605 20.6705 26.3201 20.3184 26.6284 20.055C27.2332 19.5383 27.6308 18.6633 27.6308 17.6709C27.6308 16.0831 26.613 14.7959 25.3574 14.7959C24.1018 14.7959 23.084 16.0831 23.084 17.6709C23.084 18.6634 23.4816 19.5384 24.0864 20.055C24.3948 20.3184 24.6543 20.6705 24.6543 21.076V26.1318H26.0605V21.076Z"
              fill="url(#paint27_radial_9025_76021)"
        />
      </g>
      <g filter="url(#filter10_if_9025_76021)">
        <ellipse cx="25.3574"
                 cy="17.6162"
                 rx="1.71094"
                 ry="2.22656"
                 fill="url(#paint28_radial_9025_76021)"
        />
      </g>
      <g filter="url(#filter11_i_9025_76021)">
        <path d="M23.3135 25.1982C23.3135 24.7969 23.6388 24.4663 24.04 24.4663H26.4313C27.0941 24.4663 27.6313 25.0036 27.6313 25.6663V28.8726C27.6313 29.4248 27.1836 29.8726 26.6313 29.8726H24.04C23.6388 29.8726 23.3135 29.542 23.3135 29.1407C23.3135 28.854 23.4796 28.6033 23.7208 28.4836C23.4796 28.3639 23.3135 28.1133 23.3135 27.8265C23.3135 27.5398 23.4796 27.2892 23.7208 27.1694C23.4796 27.0497 23.3135 26.7991 23.3135 26.5123C23.3135 26.2256 23.4796 25.975 23.7208 25.8553C23.4796 25.7355 23.3135 25.4849 23.3135 25.1982Z"
              fill="url(#paint29_linear_9025_76021)"
        />
        <path d="M23.3135 25.1982C23.3135 24.7969 23.6388 24.4663 24.04 24.4663H26.4313C27.0941 24.4663 27.6313 25.0036 27.6313 25.6663V28.8726C27.6313 29.4248 27.1836 29.8726 26.6313 29.8726H24.04C23.6388 29.8726 23.3135 29.542 23.3135 29.1407C23.3135 28.854 23.4796 28.6033 23.7208 28.4836C23.4796 28.3639 23.3135 28.1133 23.3135 27.8265C23.3135 27.5398 23.4796 27.2892 23.7208 27.1694C23.4796 27.0497 23.3135 26.7991 23.3135 26.5123C23.3135 26.2256 23.4796 25.975 23.7208 25.8553C23.4796 25.7355 23.3135 25.4849 23.3135 25.1982Z"
              fill="url(#paint30_radial_9025_76021)"
        />
        <path d="M23.3135 25.1982C23.3135 24.7969 23.6388 24.4663 24.04 24.4663H26.4313C27.0941 24.4663 27.6313 25.0036 27.6313 25.6663V28.8726C27.6313 29.4248 27.1836 29.8726 26.6313 29.8726H24.04C23.6388 29.8726 23.3135 29.542 23.3135 29.1407C23.3135 28.854 23.4796 28.6033 23.7208 28.4836C23.4796 28.3639 23.3135 28.1133 23.3135 27.8265C23.3135 27.5398 23.4796 27.2892 23.7208 27.1694C23.4796 27.0497 23.3135 26.7991 23.3135 26.5123C23.3135 26.2256 23.4796 25.975 23.7208 25.8553C23.4796 25.7355 23.3135 25.4849 23.3135 25.1982Z"
              fill="url(#paint31_radial_9025_76021)"
        />
        <path d="M23.3135 25.1982C23.3135 24.7969 23.6388 24.4663 24.04 24.4663H26.4313C27.0941 24.4663 27.6313 25.0036 27.6313 25.6663V28.8726C27.6313 29.4248 27.1836 29.8726 26.6313 29.8726H24.04C23.6388 29.8726 23.3135 29.542 23.3135 29.1407C23.3135 28.854 23.4796 28.6033 23.7208 28.4836C23.4796 28.3639 23.3135 28.1133 23.3135 27.8265C23.3135 27.5398 23.4796 27.2892 23.7208 27.1694C23.4796 27.0497 23.3135 26.7991 23.3135 26.5123C23.3135 26.2256 23.4796 25.975 23.7208 25.8553C23.4796 25.7355 23.3135 25.4849 23.3135 25.1982Z"
              fill="url(#paint32_radial_9025_76021)"
        />
        <path d="M23.3135 25.1982C23.3135 24.7969 23.6388 24.4663 24.04 24.4663H26.4313C27.0941 24.4663 27.6313 25.0036 27.6313 25.6663V28.8726C27.6313 29.4248 27.1836 29.8726 26.6313 29.8726H24.04C23.6388 29.8726 23.3135 29.542 23.3135 29.1407C23.3135 28.854 23.4796 28.6033 23.7208 28.4836C23.4796 28.3639 23.3135 28.1133 23.3135 27.8265C23.3135 27.5398 23.4796 27.2892 23.7208 27.1694C23.4796 27.0497 23.3135 26.7991 23.3135 26.5123C23.3135 26.2256 23.4796 25.975 23.7208 25.8553C23.4796 25.7355 23.3135 25.4849 23.3135 25.1982Z"
              fill="url(#paint33_radial_9025_76021)"
        />
      </g>
      <g filter="url(#filter12_f_9025_76021)">
        <path d="M23.833 25.8506H25.6299"
              stroke="url(#paint34_linear_9025_76021)"
              stroke-width="0.1"
              stroke-linecap="round"
        />
      </g>
      <g filter="url(#filter13_f_9025_76021)">
        <path d="M23.7549 27.1553H25.5518"
              stroke="url(#paint35_linear_9025_76021)"
              stroke-width="0.1"
              stroke-linecap="round"
        />
      </g>
      <g filter="url(#filter14_f_9025_76021)">
        <path d="M23.833 28.46H25.6299"
              stroke="url(#paint36_linear_9025_76021)"
              stroke-width="0.1"
              stroke-linecap="round"
        />
      </g>
      <g filter="url(#filter15_i_9025_76021)">
        <circle cx="10.8707"
                cy="10.6842"
                r="1.67104"
                fill="url(#paint37_radial_9025_76021)"
        />
      </g>
      <g filter="url(#filter16_f_9025_76021)">
        <circle cx="10.8709"
                cy="10.6839"
                r="0.995914"
                fill="url(#paint38_linear_9025_76021)"
        />
      </g>
      <g filter="url(#filter17_i_9025_76021)">
        <circle cx="20.3932"
                cy="10.6842"
                r="1.67104"
                fill="url(#paint39_linear_9025_76021)"
        />
        <circle cx="20.3932"
                cy="10.6842"
                r="1.67104"
                fill="url(#paint40_radial_9025_76021)"
        />
      </g>
      <g filter="url(#filter18_f_9025_76021)">
        <circle cx="20.3934"
                cy="10.6839"
                r="0.995914"
                fill="#D79E81"
        />
        <circle cx="20.3934"
                cy="10.6839"
                r="0.995914"
                fill="url(#paint41_radial_9025_76021)"
        />
        <circle cx="20.3934"
                cy="10.6839"
                r="0.995914"
                fill="url(#paint42_radial_9025_76021)"
        />
      </g>
      <g filter="url(#filter19_i_9025_76021)">
        <path d="M10.5039 8.48954C10.5039 8.22262 10.5554 7.80148 10.7702 7.64133L10.8267 7.20736C11.0952 6.99382 11.3192 7.18958 11.3192 6.86927V6.01512C11.3192 5.7482 11.4803 5.53466 11.7487 5.48128C12.393 5.32112 13.7352 5.0542 15.6681 5.0542C17.6009 5.0542 18.9432 5.32112 19.5875 5.48128C19.8022 5.53466 20.017 5.7482 20.017 6.01512V6.86927C20.017 7.18958 20.1781 7.50989 20.3928 7.72342C20.8954 8.07558 20.8641 8.26927 20.8224 8.68434C20.6422 10.4759 20.5877 12.2911 20.467 14.0877C20.3063 15.859 18.9138 17.0935 17.2536 17.0935H14.0402C12.3263 17.0935 10.9874 15.859 10.8267 14.0877C10.6877 12.2764 10.5035 10.3085 10.5039 8.48954Z"
              fill="url(#paint43_linear_9025_76021)"
        />
        <path d="M10.5039 8.48954C10.5039 8.22262 10.5554 7.80148 10.7702 7.64133L10.8267 7.20736C11.0952 6.99382 11.3192 7.18958 11.3192 6.86927V6.01512C11.3192 5.7482 11.4803 5.53466 11.7487 5.48128C12.393 5.32112 13.7352 5.0542 15.6681 5.0542C17.6009 5.0542 18.9432 5.32112 19.5875 5.48128C19.8022 5.53466 20.017 5.7482 20.017 6.01512V6.86927C20.017 7.18958 20.1781 7.50989 20.3928 7.72342C20.8954 8.07558 20.8641 8.26927 20.8224 8.68434C20.6422 10.4759 20.5877 12.2911 20.467 14.0877C20.3063 15.859 18.9138 17.0935 17.2536 17.0935H14.0402C12.3263 17.0935 10.9874 15.859 10.8267 14.0877C10.6877 12.2764 10.5035 10.3085 10.5039 8.48954Z"
              fill="url(#paint44_radial_9025_76021)"
        />
        <path d="M10.5039 8.48954C10.5039 8.22262 10.5554 7.80148 10.7702 7.64133L10.8267 7.20736C11.0952 6.99382 11.3192 7.18958 11.3192 6.86927V6.01512C11.3192 5.7482 11.4803 5.53466 11.7487 5.48128C12.393 5.32112 13.7352 5.0542 15.6681 5.0542C17.6009 5.0542 18.9432 5.32112 19.5875 5.48128C19.8022 5.53466 20.017 5.7482 20.017 6.01512V6.86927C20.017 7.18958 20.1781 7.50989 20.3928 7.72342C20.8954 8.07558 20.8641 8.26927 20.8224 8.68434C20.6422 10.4759 20.5877 12.2911 20.467 14.0877C20.3063 15.859 18.9138 17.0935 17.2536 17.0935H14.0402C12.3263 17.0935 10.9874 15.859 10.8267 14.0877C10.6877 12.2764 10.5035 10.3085 10.5039 8.48954Z"
              fill="url(#paint45_linear_9025_76021)"
        />
        <path d="M10.5039 8.48954C10.5039 8.22262 10.5554 7.80148 10.7702 7.64133L10.8267 7.20736C11.0952 6.99382 11.3192 7.18958 11.3192 6.86927V6.01512C11.3192 5.7482 11.4803 5.53466 11.7487 5.48128C12.393 5.32112 13.7352 5.0542 15.6681 5.0542C17.6009 5.0542 18.9432 5.32112 19.5875 5.48128C19.8022 5.53466 20.017 5.7482 20.017 6.01512V6.86927C20.017 7.18958 20.1781 7.50989 20.3928 7.72342C20.8954 8.07558 20.8641 8.26927 20.8224 8.68434C20.6422 10.4759 20.5877 12.2911 20.467 14.0877C20.3063 15.859 18.9138 17.0935 17.2536 17.0935H14.0402C12.3263 17.0935 10.9874 15.859 10.8267 14.0877C10.6877 12.2764 10.5035 10.3085 10.5039 8.48954Z"
              fill="url(#paint46_radial_9025_76021)"
        />
        <path d="M10.5039 8.48954C10.5039 8.22262 10.5554 7.80148 10.7702 7.64133L10.8267 7.20736C11.0952 6.99382 11.3192 7.18958 11.3192 6.86927V6.01512C11.3192 5.7482 11.4803 5.53466 11.7487 5.48128C12.393 5.32112 13.7352 5.0542 15.6681 5.0542C17.6009 5.0542 18.9432 5.32112 19.5875 5.48128C19.8022 5.53466 20.017 5.7482 20.017 6.01512V6.86927C20.017 7.18958 20.1781 7.50989 20.3928 7.72342C20.8954 8.07558 20.8641 8.26927 20.8224 8.68434C20.6422 10.4759 20.5877 12.2911 20.467 14.0877C20.3063 15.859 18.9138 17.0935 17.2536 17.0935H14.0402C12.3263 17.0935 10.9874 15.859 10.8267 14.0877C10.6877 12.2764 10.5035 10.3085 10.5039 8.48954Z"
              fill="url(#paint47_radial_9025_76021)"
        />
        <path d="M10.5039 8.48954C10.5039 8.22262 10.5554 7.80148 10.7702 7.64133L10.8267 7.20736C11.0952 6.99382 11.3192 7.18958 11.3192 6.86927V6.01512C11.3192 5.7482 11.4803 5.53466 11.7487 5.48128C12.393 5.32112 13.7352 5.0542 15.6681 5.0542C17.6009 5.0542 18.9432 5.32112 19.5875 5.48128C19.8022 5.53466 20.017 5.7482 20.017 6.01512V6.86927C20.017 7.18958 20.1781 7.50989 20.3928 7.72342C20.8954 8.07558 20.8641 8.26927 20.8224 8.68434C20.6422 10.4759 20.5877 12.2911 20.467 14.0877C20.3063 15.859 18.9138 17.0935 17.2536 17.0935H14.0402C12.3263 17.0935 10.9874 15.859 10.8267 14.0877C10.6877 12.2764 10.5035 10.3085 10.5039 8.48954Z"
              fill="url(#paint48_linear_9025_76021)"
        />
      </g>
      <g filter="url(#filter20_f_9025_76021)">
        <path d="M15.3474 10.5619L14.5262 12.2632C14.4244 12.6131 14.6687 12.963 15.0148 12.963H15.7527C16.0988 12.963 16.343 12.6077 16.2413 12.2632L15.7425 10.5619C15.6357 10.1851 15.4593 10.1851 15.3474 10.5619Z"
              fill="#C68378"
        />
      </g>
      <g filter="url(#filter21_f_9025_76021)">
        <path d="M15.2408 10.3984L14.7089 12.0996C14.6004 12.4495 14.8609 12.7994 15.2299 12.7994H16.0168C16.3859 12.7994 16.6464 12.4441 16.5378 12.0996L16.006 10.3984C15.892 10.0215 15.3602 10.0215 15.2408 10.3984Z"
              fill="#E4AC8F"
        />
        <path d="M15.2408 10.3984L14.7089 12.0996C14.6004 12.4495 14.8609 12.7994 15.2299 12.7994H16.0168C16.3859 12.7994 16.6464 12.4441 16.5378 12.0996L16.006 10.3984C15.892 10.0215 15.3602 10.0215 15.2408 10.3984Z"
              fill="url(#paint49_linear_9025_76021)"
        />
        <path d="M15.2408 10.3984L14.7089 12.0996C14.6004 12.4495 14.8609 12.7994 15.2299 12.7994H16.0168C16.3859 12.7994 16.6464 12.4441 16.5378 12.0996L16.006 10.3984C15.892 10.0215 15.3602 10.0215 15.2408 10.3984Z"
              fill="url(#paint50_linear_9025_76021)"
        />
        <path d="M15.2408 10.3984L14.7089 12.0996C14.6004 12.4495 14.8609 12.7994 15.2299 12.7994H16.0168C16.3859 12.7994 16.6464 12.4441 16.5378 12.0996L16.006 10.3984C15.892 10.0215 15.3602 10.0215 15.2408 10.3984Z"
              fill="url(#paint51_linear_9025_76021)"
        />
      </g>
      <path d="M17.0547 13.4229C17.1219 13.4138 17.1859 13.4392 17.2285 13.4834C17.2716 13.5281 17.2939 13.5931 17.2783 13.6592L17.249 13.7256C16.9048 14.2469 16.3054 14.5937 15.623 14.5938C14.9409 14.5938 14.3423 14.2466 13.998 13.7256C13.9392 13.6407 13.9609 13.545 14.0176 13.4854C14.0739 13.4263 14.1682 13.3983 14.2588 13.4443H14.2598C14.6535 13.6496 15.123 13.7676 15.623 13.7676C16.1281 13.7676 16.5925 13.6496 16.9863 13.4443L17.0547 13.4229Z"
            fill="#88024E"
            stroke="url(#paint52_linear_9025_76021)"
            stroke-width="0.1"
      />
      <path d="M18.0132 9.25195C18.6668 9.25195 19.2189 9.70256 19.3691 10.3115C19.4137 10.486 19.2798 10.6525 19.1012 10.6525H16.8684C16.7264 10.6525 16.6127 10.5226 16.6411 10.3805C16.7669 9.73909 17.3312 9.25195 18.0132 9.25195Z"
            fill="#FFFFFF"
      />
      <path d="M17.8063 9.52393C18.3016 9.52393 18.6994 9.92582 18.6994 10.417C18.6994 10.4982 18.6872 10.5794 18.6669 10.6525H16.9417C16.9214 10.5753 16.9092 10.4982 16.9092 10.417C16.9092 9.92582 17.3111 9.52393 17.8063 9.52393Z"
            fill="url(#paint53_radial_9025_76021)"
      />
      <path d="M17.2949 10.4173C17.2949 10.1331 17.5223 9.90576 17.8064 9.90576C18.0906 9.90576 18.3179 10.1331 18.3179 10.4173C18.3179 10.5025 18.2976 10.5837 18.2611 10.6527H17.3558C17.3152 10.5837 17.2949 10.5025 17.2949 10.4173Z"
            fill="black"
      />
      <g filter="url(#filter22_f_9025_76021)">
        <path d="M17.7405 9.71291C17.8041 9.79801 17.6711 9.90176 17.5199 10.0148C17.3687 10.1279 17.2565 10.2075 17.1928 10.1224C17.1292 10.0373 17.2002 9.8766 17.3514 9.76354C17.5027 9.65048 17.6768 9.62781 17.7405 9.71291Z"
              fill="#C7A7A3"
        />
        <path d="M17.7405 9.71291C17.8041 9.79801 17.6711 9.90176 17.5199 10.0148C17.3687 10.1279 17.2565 10.2075 17.1928 10.1224C17.1292 10.0373 17.2002 9.8766 17.3514 9.76354C17.5027 9.65048 17.6768 9.62781 17.7405 9.71291Z"
              fill="url(#paint54_radial_9025_76021)"
        />
      </g>
      <g filter="url(#filter23_f_9025_76021)">
        <path d="M18.6019 10.2995C18.5689 10.0686 18.4338 9.89457 18.3704 9.83643L18.1104 10.1219L18.2277 10.3502L18.6019 10.2995Z"
              fill="url(#paint55_linear_9025_76021)"
        />
      </g>
      <path d="M13.2279 9.25195C12.5743 9.25195 12.0221 9.70258 11.8719 10.3115C11.8273 10.4861 11.9612 10.6526 12.1399 10.6526H14.3727C14.5148 10.6526 14.6285 10.5226 14.6001 10.3806C14.4742 9.73912 13.9058 9.25195 13.2279 9.25195Z"
            fill="#FFFFFF"
      />
      <path d="M13.4351 9.52393C12.9398 9.52393 12.542 9.92584 12.542 10.4171C12.542 10.4983 12.5542 10.5794 12.5745 10.6525H14.2998C14.3201 10.5754 14.3323 10.4983 14.3323 10.4171C14.3283 9.92584 13.9304 9.52393 13.4351 9.52393Z"
            fill="url(#paint56_radial_9025_76021)"
      />
      <path d="M13.9464 10.4173C13.9464 10.1331 13.719 9.90576 13.4349 9.90576C13.1507 9.90576 12.9233 10.1331 12.9233 10.4173C12.9233 10.5025 12.9436 10.5837 12.9802 10.6527H13.8855C13.922 10.5837 13.9464 10.5025 13.9464 10.4173Z"
            fill="black"
      />
      <g filter="url(#filter24_f_9025_76021)">
        <path d="M14.2508 10.3121C14.2508 10.0235 14.0161 9.8311 13.9527 9.77295L13.6641 10.0521L13.8417 10.4136L14.2508 10.3121Z"
              fill="url(#paint57_linear_9025_76021)"
        />
      </g>
      <g filter="url(#filter25_f_9025_76021)">
        <ellipse cx="13.1654"
                 cy="9.90541"
                 rx="0.389901"
                 ry="0.197326"
                 transform="rotate(-27.914 13.1654 9.90541)"
                 fill="#C7A7A3"
                 fill-opacity="0.9"
        />
        <ellipse cx="13.1654"
                 cy="9.90541"
                 rx="0.389901"
                 ry="0.197326"
                 transform="rotate(-27.914 13.1654 9.90541)"
                 fill="url(#paint58_radial_9025_76021)"
        />
      </g>
      <g filter="url(#filter26_i_9025_76021)">
        <path fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.4045 8.36547C18.125 8.2981 18.587 8.57924 18.6991 8.68254C18.8911 8.85947 19.1901 8.84726 19.3671 8.65527C19.544 8.46328 19.5318 8.1642 19.3398 7.98726C19.0333 7.70481 18.3073 7.33142 17.3165 7.42409C17.0565 7.4484 16.8655 7.67884 16.8898 7.9388C16.9141 8.19876 17.1446 8.38978 17.4045 8.36547Z"
              fill="#9A6634"
        />
      </g>
      <g filter="url(#filter27_f_9025_76021)">
        <path d="M19.0195 8.22446C18.8102 8.03158 18.2162 7.70432 17.3606 7.78434"
              stroke="url(#paint59_linear_9025_76021)"
              stroke-width="0.15"
              stroke-linecap="round"
        />
      </g>
      <g filter="url(#filter28_i_9025_76021)">
        <path fill-rule="evenodd"
              clip-rule="evenodd"
              d="M13.8415 8.36547C13.1211 8.2981 12.6591 8.57924 12.547 8.68254C12.355 8.85947 12.056 8.84726 11.879 8.65527C11.7021 8.46328 11.7143 8.1642 11.9063 7.98726C12.2128 7.70481 12.9388 7.33142 13.9296 7.42409C14.1895 7.4484 14.3806 7.67884 14.3563 7.9388C14.3319 8.19876 14.1015 8.38978 13.8415 8.36547Z"
              fill="#9A6634"
        />
      </g>
      <g filter="url(#filter29_f_9025_76021)">
        <path d="M12.2271 8.22446C12.4363 8.03158 13.0303 7.70432 13.886 7.78434"
              stroke="url(#paint60_linear_9025_76021)"
              stroke-width="0.15"
              stroke-linecap="round"
        />
      </g>
      <path d="M9.80055 8.59832V7.16064H11.2761C11.2288 7.29937 11.0774 7.63167 10.8504 7.85111C10.6234 8.07054 10.5478 8.44699 10.5478 8.6598V10.0549C10.3113 10.0549 10.2167 9.94141 9.99918 9.52524C9.82514 9.19231 9.79425 8.76857 9.80055 8.59832Z"
            fill="url(#paint61_linear_9025_76021)"
      />
      <path d="M9.80055 8.59832V7.16064H11.2761C11.2288 7.29937 11.0774 7.63167 10.8504 7.85111C10.6234 8.07054 10.5478 8.44699 10.5478 8.6598V10.0549C10.3113 10.0549 10.2167 9.94141 9.99918 9.52524C9.82514 9.19231 9.79425 8.76857 9.80055 8.59832Z"
            fill="url(#paint62_radial_9025_76021)"
      />
      <path d="M21.4553 8.59832V7.16064H19.9798C20.0271 7.29937 20.1784 7.63167 20.4054 7.85111C20.6324 8.07054 20.7081 8.44699 20.7081 8.6598V10.0549C20.9446 10.0549 21.0391 9.94141 21.2567 9.52524C21.4307 9.19231 21.4616 8.76857 21.4553 8.59832Z"
            fill="url(#paint63_linear_9025_76021)"
      />
      <path d="M21.4553 8.59832V7.16064H19.9798C20.0271 7.29937 20.1784 7.63167 20.4054 7.85111C20.6324 8.07054 20.7081 8.44699 20.7081 8.6598V10.0549C20.9446 10.0549 21.0391 9.94141 21.2567 9.52524C21.4307 9.19231 21.4616 8.76857 21.4553 8.59832Z"
            fill="url(#paint64_radial_9025_76021)"
      />
      <g filter="url(#filter30_i_9025_76021)">
        <path d="M10.2504 1.98779C9.18256 1.98779 8.31689 2.85343 8.31689 3.92125C8.31689 4.74923 8.83737 5.45564 9.56895 5.73121C9.65226 5.76259 9.71155 5.83991 9.71155 5.92894V6.98046C9.71155 7.22899 9.91302 7.43046 10.1616 7.43046H21.2607C21.5093 7.43046 21.7108 7.22899 21.7108 6.98046V5.92551C21.7108 5.83684 21.7696 5.75976 21.8524 5.72813C22.5797 5.4504 23.0963 4.74615 23.0963 3.92125C23.0963 2.85343 22.2307 1.98779 21.1628 1.98779H10.2504Z"
              fill="url(#paint65_radial_9025_76021)"
        />
        <path d="M10.2504 1.98779C9.18256 1.98779 8.31689 2.85343 8.31689 3.92125C8.31689 4.74923 8.83737 5.45564 9.56895 5.73121C9.65226 5.76259 9.71155 5.83991 9.71155 5.92894V6.98046C9.71155 7.22899 9.91302 7.43046 10.1616 7.43046H21.2607C21.5093 7.43046 21.7108 7.22899 21.7108 6.98046V5.92551C21.7108 5.83684 21.7696 5.75976 21.8524 5.72813C22.5797 5.4504 23.0963 4.74615 23.0963 3.92125C23.0963 2.85343 22.2307 1.98779 21.1628 1.98779H10.2504Z"
              fill="url(#paint66_radial_9025_76021)"
        />
        <path d="M10.2504 1.98779C9.18256 1.98779 8.31689 2.85343 8.31689 3.92125C8.31689 4.74923 8.83737 5.45564 9.56895 5.73121C9.65226 5.76259 9.71155 5.83991 9.71155 5.92894V6.98046C9.71155 7.22899 9.91302 7.43046 10.1616 7.43046H21.2607C21.5093 7.43046 21.7108 7.22899 21.7108 6.98046V5.92551C21.7108 5.83684 21.7696 5.75976 21.8524 5.72813C22.5797 5.4504 23.0963 4.74615 23.0963 3.92125C23.0963 2.85343 22.2307 1.98779 21.1628 1.98779H10.2504Z"
              fill="url(#paint67_radial_9025_76021)"
        />
      </g>
      <path d="M21.7365 5.82764H9.68408C9.70166 5.85788 9.71161 5.89246 9.71161 5.92903V6.98055C9.71161 7.22908 9.91309 7.43055 10.1616 7.43055H21.2608C21.5093 7.43055 21.7108 7.22908 21.7108 6.98055V5.9256C21.7108 5.89042 21.7201 5.85706 21.7365 5.82764Z"
            fill="url(#paint68_radial_9025_76021)"
      />
      <path d="M21.7365 5.82764H9.68408C9.70166 5.85788 9.71161 5.89246 9.71161 5.92903V6.98055C9.71161 7.22908 9.91309 7.43055 10.1616 7.43055H21.2608C21.5093 7.43055 21.7108 7.22908 21.7108 6.98055V5.9256C21.7108 5.89042 21.7201 5.85706 21.7365 5.82764Z"
            fill="url(#paint69_linear_9025_76021)"
      />
      <g filter="url(#filter31_f_9025_76021)">
        <path d="M13.1386 5.7776L12.6641 3.93018V5.7776H13.1386Z"
              fill="url(#paint70_linear_9025_76021)"
        />
      </g>
      <g filter="url(#filter32_f_9025_76021)">
        <path d="M18.2515 5.7776L18.726 3.93018V5.7776H18.2515Z"
              fill="url(#paint71_linear_9025_76021)"
        />
      </g>
      <g filter="url(#filter33_f_9025_76021)">
        <rect x="15.4204"
              y="3.64062"
              width="0.579573"
              height="2.13722"
              fill="url(#paint72_linear_9025_76021)"
        />
      </g>
    </g>
    <defs>
      <filter id="filter0_i_9025_76021"
              x="8.38115"
              y="17.9028"
              width="14.3"
              height="12.3"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="-0.3"
                  dy="0.3"
        />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 1 0 0 0 0 0.972549 0 0 0 0 0.996078 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter1_f_9025_76021"
              x="12.0229"
              y="16.7479"
              width="6.53828"
              height="5.7707"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.325"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter2_f_9025_76021"
              x="18.4717"
              y="26.9277"
              width="2.5"
              height="2.5"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.25"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter3_f_9025_76021"
              x="18.4717"
              y="23.2876"
              width="2.5"
              height="2.5"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.25"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter4_f_9025_76021"
              x="18.4717"
              y="19.6577"
              width="2.5"
              height="2.5"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.25"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter5_ii_9025_76021"
              x="19.1412"
              y="27.1827"
              width="1.7"
              height="1.7"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.1"
                  dy="-0.1"
        />
        <feGaussianBlur stdDeviation="0.05" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.619608 0 0 0 0 0.521569 0 0 0 0 0.647059 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="-0.1"
                  dy="0.1"
        />
        <feGaussianBlur stdDeviation="0.05" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.701961 0 0 0 0 0.658824 0 0 0 0 0.705882 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="effect1_innerShadow_9025_76021"
                 result="effect2_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter6_ii_9025_76021"
              x="19.1412"
              y="23.5426"
              width="1.7"
              height="1.7"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.1"
                  dy="-0.1"
        />
        <feGaussianBlur stdDeviation="0.05" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.619608 0 0 0 0 0.521569 0 0 0 0 0.647059 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="-0.1"
                  dy="0.1"
        />
        <feGaussianBlur stdDeviation="0.05" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.701961 0 0 0 0 0.658824 0 0 0 0 0.705882 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="effect1_innerShadow_9025_76021"
                 result="effect2_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter7_ii_9025_76021"
              x="19.1412"
              y="19.9127"
              width="1.7"
              height="1.7"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.1"
                  dy="-0.1"
        />
        <feGaussianBlur stdDeviation="0.05" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.619608 0 0 0 0 0.521569 0 0 0 0 0.647059 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="-0.1"
                  dy="0.1"
        />
        <feGaussianBlur stdDeviation="0.05" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.701961 0 0 0 0 0.658824 0 0 0 0 0.705882 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="effect1_innerShadow_9025_76021"
                 result="effect2_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter8_ii_9025_76021"
              x="14.5314"
              y="17.2413"
              width="2.23799"
              height="1.80898"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="-0.2" />
        <feGaussianBlur stdDeviation="0.15" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.815686 0 0 0 0 0.266667 0 0 0 0 0.376471 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.1"
                  dy="-0.1"
        />
        <feGaussianBlur stdDeviation="0.2" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.65098 0 0 0 0 0.176471 0 0 0 0 0.254902 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="effect1_innerShadow_9025_76021"
                 result="effect2_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter9_i_9025_76021"
              x="23.084"
              y="14.7959"
              width="5.04688"
              height="11.3359"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.75" />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.862745 0 0 0 0 0.552941 0 0 0 0 0.345098 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter10_if_9025_76021"
              x="23.5465"
              y="15.2396"
              width="3.67188"
              height="4.70313"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.15"
                  dy="-0.15"
        />
        <feGaussianBlur stdDeviation="0.1" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.933333 0 0 0 0 0.662745 0 0 0 0 0.494118 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
        <feGaussianBlur stdDeviation="0.05"
                        result="effect2_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter11_i_9025_76021"
              x="23.3135"
              y="24.3163"
              width="4.46787"
              height="5.55625"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.15"
                  dy="-0.15"
        />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.658824 0 0 0 0 0.443137 0 0 0 0 0.411765 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter12_f_9025_76021"
              x="23.6832"
              y="25.7008"
              width="2.09648"
              height="0.299609"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.05"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter13_f_9025_76021"
              x="23.6051"
              y="27.0055"
              width="2.09648"
              height="0.299609"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.05"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter14_f_9025_76021"
              x="23.6832"
              y="28.3102"
              width="2.09648"
              height="0.299609"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.05"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter15_i_9025_76021"
              x="9.19971"
              y="9.01318"
              width="3.54229"
              height="3.34229"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.2" />
        <feGaussianBlur stdDeviation="0.2" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.866667 0 0 0 0 0.643137 0 0 0 0 0.533333 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter16_f_9025_76021"
              x="9.375"
              y="9.18799"
              width="2.9917"
              height="2.9917"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.25"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter17_i_9025_76021"
              x="18.7222"
              y="8.76318"
              width="3.59229"
              height="3.59229"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.25"
                  dy="-0.25"
        />
        <feGaussianBlur stdDeviation="0.25" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.768627 0 0 0 0 0.529412 0 0 0 0 0.505882 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter18_f_9025_76021"
              x="18.8975"
              y="9.18799"
              width="2.9917"
              height="2.9917"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.25"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter19_i_9025_76021"
              x="10.5039"
              y="5.0542"
              width="10.3398"
              height="12.1891"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dy="0.15" />
        <feGaussianBlur stdDeviation="0.15" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.752941 0 0 0 0 0.501961 0 0 0 0 0.34902 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter20_f_9025_76021"
              x="13.7529"
              y="9.5293"
              width="3.26172"
              height="4.18359"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.375"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter21_f_9025_76021"
              x="14.4341"
              y="9.86572"
              width="2.37842"
              height="3.18359"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.125"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter22_f_9025_76021"
              x="17.0694"
              y="9.56162"
              width="0.787402"
              height="0.696582"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.05"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter23_f_9025_76021"
              x="17.9104"
              y="9.63643"
              width="0.891699"
              height="0.913672"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.1"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter24_f_9025_76021"
              x="13.4641"
              y="9.57295"
              width="0.986914"
              height="1.04063"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.1"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter25_f_9025_76021"
              x="12.7086"
              y="9.55283"
              width="0.913867"
              height="0.704883"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.05"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter26_i_9025_76021"
              x="16.8877"
              y="7.00967"
              width="2.85449"
              height="1.79795"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.25"
                  dy="-0.4"
        />
        <feGaussianBlur stdDeviation="0.3" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.47451 0 0 0 0 0.262745 0 0 0 0 0.168627 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter27_f_9025_76021"
              x="16.9856"
              y="7.39678"
              width="2.40908"
              height="1.20254"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.15"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter28_i_9025_76021"
              x="11.7539"
              y="7.00967"
              width="2.85449"
              height="1.79795"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dx="0.25"
                  dy="-0.4"
        />
        <feGaussianBlur stdDeviation="0.3" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.47451 0 0 0 0 0.262745 0 0 0 0 0.168627 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter29_f_9025_76021"
              x="11.8519"
              y="7.39678"
              width="2.40908"
              height="1.20254"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.15"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter30_i_9025_76021"
              x="8.31689"
              y="1.98779"
              width="14.7793"
              height="5.54287"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feColorMatrix in="SourceAlpha"
                       type="matrix"
                       values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                       result="hardAlpha"
        />
        <feOffset dy="0.1" />
        <feGaussianBlur stdDeviation="0.375" />
        <feComposite in2="hardAlpha"
                     operator="arithmetic"
                     k2="-1"
                     k3="1"
        />
        <feColorMatrix type="matrix"
                       values="0 0 0 0 0.790803 0 0 0 0 0.768636 0 0 0 0 0.790803 0 0 0 1 0"
        />
        <feBlend mode="normal"
                 in2="shape"
                 result="effect1_innerShadow_9025_76021"
        />
      </filter>
      <filter id="filter31_f_9025_76021"
              x="12.5641"
              y="3.83018"
              width="0.674609"
              height="2.04766"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.05"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter32_f_9025_76021"
              x="18.1515"
              y="3.83018"
              width="0.674609"
              height="2.04766"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.05"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <filter id="filter33_f_9025_76021"
              x="15.2204"
              y="3.44062"
              width="0.97959"
              height="2.53721"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0"
                 result="BackgroundImageFix"
        />
        <feBlend mode="normal"
                 in="SourceGraphic"
                 in2="BackgroundImageFix"
                 result="shape"
        />
        <feGaussianBlur stdDeviation="0.1"
                        result="effect1_foregroundBlur_9025_76021"
        />
      </filter>
      <radialGradient id="paint0_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.322 17.9832) rotate(22.5332) scale(3.18029 4.8153)"
      >
        <stop offset="0.384957"
              stop-color="#DCCAD4"
        />
        <stop offset="1"
              stop-color="#DCCAD4"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint1_linear_9025_76021"
                      x1="22.8388"
                      y1="25.7707"
                      x2="26.0821"
                      y2="25.7707"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0909091"
              stop-color="#CBC3CB"
        />
        <stop offset="1"
              stop-color="#E7E2EB"
        />
      </linearGradient>
      <radialGradient id="paint2_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(23.6938 30.105) rotate(-90) scale(5.95598 3.29746)"
      >
        <stop stop-color="#A78BB9" />
        <stop offset="1"
              stop-color="#A78BB9"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint3_linear_9025_76021"
                      x1="7.82196"
                      y1="30.8894"
                      x2="7.82196"
                      y2="16.8269"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B59CCC" />
        <stop offset="1"
              stop-color="#9C979A"
        />
      </linearGradient>
      <linearGradient id="paint4_linear_9025_76021"
                      x1="8.68115"
                      y1="26.5144"
                      x2="8.10321"
                      y2="26.5144"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A79EB4" />
        <stop offset="1"
              stop-color="#A498B2"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint5_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.13446 30.6081) rotate(-90) scale(8.375 0.96875)"
      >
        <stop stop-color="#B8A1D0" />
        <stop offset="1"
              stop-color="#B8A1D0"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(9.22158 29.3187) rotate(180) scale(4.94559 18.6532)"
      >
        <stop offset="0.584746"
              stop-color="#DFC3C4"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#DFC3C4"
        />
      </radialGradient>
      <radialGradient id="paint7_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.7354 19.5801) rotate(136.66) scale(12.6487 9.75991)"
      >
        <stop stop-color="#E9DAE3" />
        <stop offset="1"
              stop-color="#D8C4E9"
        />
      </radialGradient>
      <radialGradient id="paint8_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.3994 32.3527) rotate(-90) scale(8.04958 5.03716)"
      >
        <stop stop-color="#CFAEE5" />
        <stop offset="1"
              stop-color="#CFAEE5"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint9_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.4127 17.1144) rotate(75.0686) scale(4.00951 7.09045)"
      >
        <stop stop-color="#A196A1" />
        <stop offset="1"
              stop-color="#A196A1"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint10_linear_9025_76021"
                      x1="8.68115"
                      y1="27.1011"
                      x2="12.618"
                      y2="27.1011"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9E8FAD" />
        <stop offset="1"
              stop-color="#C0B0D1"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint11_linear_9025_76021"
                      x1="16.2897"
                      y1="22.0207"
                      x2="13.3288"
                      y2="18.636"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AA7AA4" />
        <stop offset="1"
              stop-color="#9C8395"
        />
      </linearGradient>
      <radialGradient id="paint12_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.6972 16.8151) rotate(161.865) scale(9.17449 5.46828)"
      >
        <stop stop-color="#E94574" />
        <stop offset="1"
              stop-color="#B22A4E"
        />
      </radialGradient>
      <radialGradient id="paint13_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.2575 15.9824) rotate(164.745) scale(5.28552 3.04675)"
      >
        <stop offset="0.38277"
              stop-color="#8D0C24"
        />
        <stop offset="1"
              stop-color="#8D0C24"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint14_linear_9025_76021"
                      x1="20.5095"
                      y1="27.5346"
                      x2="19.2412"
                      y2="28.9409"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A698AB" />
        <stop offset="1"
              stop-color="#9F8AA8"
        />
      </linearGradient>
      <linearGradient id="paint15_linear_9025_76021"
                      x1="20.5095"
                      y1="23.8945"
                      x2="19.2412"
                      y2="25.3007"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A698AB" />
        <stop offset="1"
              stop-color="#9F8AA8"
        />
      </linearGradient>
      <linearGradient id="paint16_linear_9025_76021"
                      x1="20.5095"
                      y1="20.2646"
                      x2="19.2412"
                      y2="21.6708"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A698AB" />
        <stop offset="1"
              stop-color="#9F8AA8"
        />
      </linearGradient>
      <radialGradient id="paint17_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-1.93357 1.31957 -1.30121 -1.89486 27.9665 23.5869)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.463759"
              stop-color="#DEAF8E"
        />
        <stop offset="1"
              stop-color="#B27959"
        />
      </radialGradient>
      <radialGradient id="paint18_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(0.762218 -0.580363 0.4465 0.582782 27.3953 23.4406)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.131677"
              stop-color="#E6BEA1"
        />
        <stop offset="1"
              stop-color="#E6BEA1"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint19_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.869 19.1865) rotate(120.659) scale(3.52381 1.94656)"
      >
        <stop offset="0.19825"
              stop-color="#DE3D65"
        />
        <stop offset="1"
              stop-color="#B92C4A"
        />
      </radialGradient>
      <radialGradient id="paint20_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.2283 18.0615) rotate(71.0296) scale(2.11487 1.48779)"
      >
        <stop offset="0.336576"
              stop-color="#9C1931"
        />
        <stop offset="1"
              stop-color="#C93356"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint21_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(14.3396 20.3584) rotate(-62.6962) scale(1.49465 0.886946)"
      >
        <stop stop-color="#EA4067" />
        <stop offset="1"
              stop-color="#DA3158"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint22_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.2057 18.4771) rotate(59.7976) scale(4.02091 3.12645)"
      >
        <stop offset="0.314786"
              stop-color="#E33964"
        />
        <stop offset="1"
              stop-color="#BF2245"
        />
      </radialGradient>
      <linearGradient id="paint23_linear_9025_76021"
                      x1="16.3847"
                      y1="17.8897"
                      x2="17.3691"
                      y2="19.0615"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C52759" />
        <stop offset="1"
              stop-color="#C52759"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint24_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.7597 18.7803) rotate(114.88) scale(1.18842 0.961628)"
      >
        <stop stop-color="#9C1931" />
        <stop offset="1"
              stop-color="#9C1931"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint25_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.6972 21.1865) rotate(-119.374) scale(2.99434 1.03352)"
      >
        <stop offset="0.37062"
              stop-color="#DF3D53"
        />
        <stop offset="1"
              stop-color="#DF3D53"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint26_linear_9025_76021"
                      x1="15.8999"
                      y1="18.7803"
                      x2="15.8999"
                      y2="17.3413"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C43656" />
        <stop offset="1"
              stop-color="#B1203D"
        />
        <stop offset="1"
              stop-color="#BA2946"
        />
      </linearGradient>
      <radialGradient id="paint27_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.1967 15.9678) rotate(153.435) scale(1.57224 3.24929)"
      >
        <stop offset="0.524444"
              stop-color="#F4B183"
        />
        <stop offset="1"
              stop-color="#F4B183"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint28_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.6654 16.9834) rotate(96.1476) scale(2.87591 2.5871)"
      >
        <stop offset="0.356017"
              stop-color="#E4976B"
        />
        <stop offset="0.745781"
              stop-color="#E29457"
        />
      </radialGradient>
      <linearGradient id="paint29_linear_9025_76021"
                      x1="27.3415"
                      y1="27.9351"
                      x2="23.3135"
                      y2="27.9351"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.145558"
              stop-color="#F3C29F"
        />
        <stop offset="0.861163"
              stop-color="#C68B80"
        />
      </linearGradient>
      <radialGradient id="paint30_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.7506 25.1772) rotate(90) scale(0.801703 1.35439)"
      >
        <stop offset="0.106061"
              stop-color="#F8C8AD"
        />
        <stop offset="1"
              stop-color="#F2C49E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint31_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.7506 26.4716) rotate(90) scale(0.859375 1.45182)"
      >
        <stop offset="0.109091"
              stop-color="#F8C8AD"
        />
        <stop offset="1"
              stop-color="#F2C49E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint32_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.7506 27.7216) rotate(90) scale(0.71875 1.21425)"
      >
        <stop offset="0.109091"
              stop-color="#F8C8AD"
        />
        <stop offset="1"
              stop-color="#F2C49E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint33_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.7506 29.0732) rotate(90) scale(0.799377 1.7273)"
      >
        <stop offset="0.186046"
              stop-color="#F8C8AD"
        />
        <stop offset="1"
              stop-color="#F2C49E"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint34_linear_9025_76021"
                      x1="23.833"
                      y1="25.9287"
                      x2="25.5422"
                      y2="25.9287"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AE7759" />
        <stop offset="1"
              stop-color="#C08666"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint35_linear_9025_76021"
                      x1="23.7549"
                      y1="27.2334"
                      x2="25.4641"
                      y2="27.2334"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AE7759" />
        <stop offset="1"
              stop-color="#C08666"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint36_linear_9025_76021"
                      x1="23.833"
                      y1="28.5381"
                      x2="25.5422"
                      y2="28.5381"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AE7759" />
        <stop offset="1"
              stop-color="#C08666"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint37_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(9.19971 10.6842) scale(1.75652 3.07393)"
      >
        <stop offset="0.350532"
              stop-color="#C28775"
        />
        <stop offset="1"
              stop-color="#BA7867"
        />
      </radialGradient>
      <linearGradient id="paint38_linear_9025_76021"
                      x1="10.8709"
                      y1="10.9628"
                      x2="10.2297"
                      y2="10.9628"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AF6F5D" />
        <stop offset="1"
              stop-color="#B87862"
        />
      </linearGradient>
      <linearGradient id="paint39_linear_9025_76021"
                      x1="21.4807"
                      y1="9.59163"
                      x2="20.6612"
                      y2="12.1303"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F5C8A5" />
        <stop offset="1"
              stop-color="#DCA189"
        />
      </linearGradient>
      <radialGradient id="paint40_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.7657 10.4191) rotate(-36.0604) scale(1.02361 1.16832)"
      >
        <stop offset="0.542503"
              stop-color="#E3AB88"
        />
        <stop offset="1"
              stop-color="#E3AB88"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint41_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.352 11.506) rotate(-61.4675) scale(1.72098 1.0073)"
      >
        <stop offset="0.689542"
              stop-color="#D79A76"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#D79A76"
        />
      </radialGradient>
      <radialGradient id="paint42_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.3934 10.6839) rotate(44.7077) scale(0.365178 0.470765)"
      >
        <stop stop-color="#CB8E6D" />
        <stop offset="1"
              stop-color="#CB8E6D"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint43_linear_9025_76021"
                      x1="19.6678"
                      y1="11.0738"
                      x2="12.0545"
                      y2="12.2035"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAC39E" />
        <stop offset="1"
              stop-color="#C9917C"
        />
      </linearGradient>
      <radialGradient id="paint44_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.1144 7.33898) rotate(90) scale(10.6803 10.161)"
      >
        <stop offset="0.651099"
              stop-color="#CB8E88"
              stop-opacity="0"
        />
        <stop offset="0.952472"
              stop-color="#AC6061"
        />
      </radialGradient>
      <linearGradient id="paint45_linear_9025_76021"
                      x1="10.2668"
                      y1="13.7724"
                      x2="12.5721"
                      y2="13.4729"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D99E84" />
        <stop offset="1"
              stop-color="#D99E84"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint46_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.9834 9.41132) rotate(-90) scale(1.30832 1.60345)"
      >
        <stop stop-color="#E2A18C" />
        <stop offset="1"
              stop-color="#E2A18C"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint47_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.4403 9.37777) rotate(-90) scale(1.39218 1.72401)"
      >
        <stop stop-color="#C2837A" />
        <stop offset="1"
              stop-color="#C2837A"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint48_linear_9025_76021"
                      x1="15.6738"
                      y1="6.98041"
                      x2="15.6738"
                      y2="8.26166"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.195122"
              stop-color="#C38475"
        />
        <stop offset="1"
              stop-color="#C38475"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint49_linear_9025_76021"
                      x1="14.7584"
                      y1="11.7336"
                      x2="15.6975"
                      y2="11.7336"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CB9173" />
        <stop offset="1"
              stop-color="#CB9173"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint50_linear_9025_76021"
                      x1="16.5627"
                      y1="12.0564"
                      x2="15.5361"
                      y2="12.0418"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FEC8A4" />
        <stop offset="1"
              stop-color="#FEC8A4"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint51_linear_9025_76021"
                      x1="15.8181"
                      y1="12.7994"
                      x2="15.8181"
                      y2="12.2259"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C98583" />
        <stop offset="1"
              stop-color="#C98583"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint52_linear_9025_76021"
                      x1="14.5849"
                      y1="14.4164"
                      x2="15.0203"
                      y2="13.7282"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D79E8E" />
        <stop offset="0.663171"
              stop-color="#D79E8E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint53_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.8043 10.0013) rotate(90) scale(0.811899 1.29142)"
      >
        <stop offset="0.80198"
              stop-color="#7D574A"
        />
        <stop offset="1"
              stop-color="#694B43"
        />
        <stop offset="1"
              stop-color="#804D49"
        />
        <stop offset="1"
              stop-color="#664944"
        />
      </radialGradient>
      <radialGradient id="paint54_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.232082 -0.299071 0.408244 -0.324039 17.5758 10.0857)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.765532"
              stop-color="#FFE6E2"
              stop-opacity="0"
        />
        <stop offset="0.966159"
              stop-color="#FFE6E2"
        />
      </radialGradient>
      <linearGradient id="paint55_linear_9025_76021"
                      x1="18.5829"
                      y1="10.0553"
                      x2="18.2689"
                      y2="10.2487"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B4948D" />
        <stop offset="1"
              stop-color="#B4948D"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint56_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.4372 10.0013) rotate(90) scale(0.811941 1.29148)"
      >
        <stop offset="0.80198"
              stop-color="#7D574A"
        />
        <stop offset="1"
              stop-color="#694B43"
        />
        <stop offset="1"
              stop-color="#804D49"
        />
        <stop offset="1"
              stop-color="#664944"
        />
      </radialGradient>
      <linearGradient id="paint57_linear_9025_76021"
                      x1="14.1813"
                      y1="10.0552"
                      x2="13.8673"
                      y2="10.2487"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B4948D" />
        <stop offset="1"
              stop-color="#B4948D"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint58_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.00774145 -0.494437 0.594171 -0.0196762 13.1503 10.2206)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.765532"
              stop-color="#FFE6E2"
              stop-opacity="0"
        />
        <stop offset="0.966159"
              stop-color="#FFE6E2"
        />
      </radialGradient>
      <linearGradient id="paint59_linear_9025_76021"
                      x1="17.8429"
                      y1="7.90845"
                      x2="18.3246"
                      y2="7.06721"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A57146" />
        <stop offset="1"
              stop-color="#A57146"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint60_linear_9025_76021"
                      x1="13.4037"
                      y1="7.90845"
                      x2="12.922"
                      y2="7.06721"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A57146" />
        <stop offset="1"
              stop-color="#A57146"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint61_linear_9025_76021"
                      x1="10.4451"
                      y1="8.56685"
                      x2="9.7998"
                      y2="8.56685"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#DDA689" />
        <stop offset="1"
              stop-color="#F3C099"
        />
      </linearGradient>
      <radialGradient id="paint62_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.1717 7.43367) rotate(110.072) scale(1.84653 0.570192)"
      >
        <stop offset="0.221775"
              stop-color="#CD9270"
        />
        <stop offset="1"
              stop-color="#CD9270"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint63_linear_9025_76021"
                      x1="20.7179"
                      y1="7.54454"
                      x2="20.7179"
                      y2="10.0549"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAD0A4" />
        <stop offset="1"
              stop-color="#F7C295"
        />
      </linearGradient>
      <radialGradient id="paint64_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20.2501 7.99394) rotate(75.4111) scale(1.347 0.784291)"
      >
        <stop offset="0.116696"
              stop-color="#CF9966"
        />
        <stop offset="1"
              stop-color="#CF9966"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint65_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(12.5406 5.95218) rotate(-90) scale(3.96438 18.8689)"
      >
        <stop offset="0.244363"
              stop-color="#AA92C2"
        />
        <stop offset="1"
              stop-color="#D5D3D8"
        />
      </radialGradient>
      <radialGradient id="paint66_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(24.3531 2.79593) rotate(-180) scale(15.4062 5.61228)"
      >
        <stop offset="0.107143"
              stop-color="#F9F6FC"
        />
        <stop offset="1"
              stop-color="#E7DDF2"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint67_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(8.31689 3.89795) scale(2.67803 3.53252)"
      >
        <stop stop-color="#E7D1CD" />
        <stop offset="1"
              stop-color="#B8A5CA"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint68_radial_9025_76021"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.7906 7.20227) rotate(-90.7252) scale(2.46895 8.06304)"
      >
        <stop offset="0.178949"
              stop-color="#EEE3F8"
        />
        <stop offset="1"
              stop-color="#B1A3BF"
        />
      </radialGradient>
      <linearGradient id="paint69_linear_9025_76021"
                      x1="16.2906"
                      y1="7.67102"
                      x2="16.2906"
                      y2="6.98352"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AB8BB8" />
        <stop offset="1"
              stop-color="#AB8BB8"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint70_linear_9025_76021"
                      x1="13.037"
                      y1="5.52333"
                      x2="12.4587"
                      y2="5.42567"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.297367"
              stop-color="#A28CB9"
        />
        <stop offset="1"
              stop-color="#A28CB9"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint71_linear_9025_76021"
                      x1="18.2985"
                      y1="5.33192"
                      x2="18.9313"
                      y2="5.42567"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.246377"
              stop-color="#B39FC7"
        />
        <stop offset="1"
              stop-color="#B39FC7"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint72_linear_9025_76021"
                      x1="16"
                      y1="5.6681"
                      x2="16"
                      y2="3.64063"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.100186"
              stop-color="#A990C1"
        />
        <stop offset="1"
              stop-color="#A990C1"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_9025_76021">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
